import * as React from 'react';

import { VALID_FONTS } from '../../../../lib/StyledComponents/Theme/common';
import { VALID_COLOR_DATA, VALID_EDGE_STYLE_DATA, VALID_MEDIA_STYLES } from '../../Utils';
import { VALID_TEXT_TRANSFORM } from '../common';

import { ITextCommonProps } from './common';
import { StyledText } from './StyledText';

export interface ITextProps extends ITextCommonProps {
  color?: VALID_COLOR_DATA;
  display?: VALID_MEDIA_STYLES;
  family?: VALID_FONTS;
  // tslint:disable: no-any
  forwardedAs?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  letterSpacing?: string;
  margin?: VALID_EDGE_STYLE_DATA;
  order?: string;
  padding?: VALID_EDGE_STYLE_DATA;
  transform?: VALID_TEXT_TRANSFORM;
}

const Text: React.FC<ITextProps> = ({
  align,
  alignSelf,
  backgroundColor,
  children,
  decoration,
  flexBasis,
  flexGrow,
  flexShrink,
  forwardedAs,
  letterSpacing,
  lineHeight,
  round,
  size = 'body',
  verticalAlign,
  weight,
  /* properties below are munged to avoid styled-components writing them to the DOM */
  color,
  display,
  family,
  fontStyle,
  margin,
  transform,
  order,
  padding,
  ...rest
}) => (
  <StyledText
    {...rest}
    align={align}
    alignSelf={alignSelf}
    as={forwardedAs}
    backgroundColor={backgroundColor}
    colorProp={color}
    decoration={decoration}
    displayProp={display}
    fontStyle={fontStyle}
    flexBasis={flexBasis}
    flexGrow={flexGrow}
    flexShrink={flexShrink}
    fontType={family}
    letterSpacing={letterSpacing}
    lineHeight={lineHeight}
    marginProp={margin}
    orderProp={order}
    paddingProp={padding}
    round={round}
    size={size}
    textTransform={transform}
    verticalAlign={verticalAlign}
    weight={weight}
  >
    {children}
  </StyledText>
);

export default Text;
